import { useEffect } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { trackLegacyRedirect } from '@/utils/analytics';

interface LegacyAppRedirectProps {
  to: string;
}

/**
 * Redirects legacy routes to new /app/* namespace
 * Logs telemetry and console warnings for debugging
 * Handles dynamic route parameters
 */
export const LegacyAppRedirect = ({ to }: LegacyAppRedirectProps) => {
  const location = useLocation();
  const params = useParams();
  const { user } = useAuth();

  useEffect(() => {
    const from = location.pathname;
    
    // Track redirect with centralized analytics
    trackLegacyRedirect(
      from,
      to,
      user?.id,
      user?.highestRole
    );
  }, [location.pathname, to, user]);

  // Replace dynamic parameters in the target path
  let targetPath = to;
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      targetPath = targetPath.replace(`:${key}`, value);
    }
  });

  return <Navigate to={targetPath} replace />;
};
